import React, { useRef, useState, useCallback } from 'react';
import { Img, View, Text } from '@smarterservices/smarter-ui';
import CONSTANTS from '../../../config/constants';
import VideoMagnifier from '../../Common/VideoMagnifier';
import { useAppStore, getAppStore } from '../../../stores/StoreContext';

const IdentificationImage = ({ imageUrl }) => {
    const imageRef = useRef(null);
    const containerRef = useRef(null);
    const appStoreInstance = getAppStore(); // Get raw store instance

    const magnification = useAppStore((state) => state.magnification);
    const updateMagnification = useAppStore((state) => state.updateMagnification);

    const handleLevelChange = useCallback((newLevel) => {
        const currentMagnification = appStoreInstance.getState().magnification;
        appStoreInstance.getState().updateMagnification({ ...currentMagnification, level: newLevel });
    }, [appStoreInstance]);

    const handleLensSizeChange = useCallback((newSize) => {
        const currentMagnification = appStoreInstance.getState().magnification;
        appStoreInstance.getState().updateMagnification({ ...currentMagnification, lensSize: newSize });
    }, [appStoreInstance]);

    return (
        <View as="div" textAlign="center">
            {imageUrl ? (
                <VideoMagnifier
                    mediaRef={imageRef}
                    containerRef={containerRef}
                    enabled={magnification?.enabled}
                    level={magnification?.level}
                    lensSize={magnification?.lensSize}
                    onLevelChange={handleLevelChange}
                    onLensSizeChange={handleLensSizeChange}
                >
                    <div
                        ref={containerRef}
                        style={{
                            display: 'inline-block',
                            border: '1px solid #0374B5',
                            boxShadow: '0 0.125rem 0.1875rem rgba(0, 0, 0, 0.2)',
                            overflow: 'visible'
                        }}
                    >
                        <img
                            ref={imageRef}
                            src={imageUrl}
                            crossOrigin="anonymous"
                            style={{ display: 'block', maxWidth: '100%', height: 'auto' }}
                            alt="Identity verification"
                        />
                    </div>
                </VideoMagnifier>
            ) : (
                <View as="div" margin="large 0 0 0">
                    <Text variant={CONSTANTS.STYLES.CARD_BODY_TEXT_VARIANT}>
                        No Image Found
                    </Text>
                </View>
            )}
        </View>
    );
};

export default IdentificationImage;
